import { Device } from 'DeviceUtils';
import { StyleSheet } from 'react-native';
import { fontStyles } from 'Theme';

const defaultStyles = StyleSheet.create({
    container: {
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center'
    },
    title: {
        ...fontStyles.title,
        color: 'white',
        textAlign: 'center',
        width: Device.isTabletOrWeb ? '45%' : '65%'
    },
    hrStyle: {
        width: Device.isTablet ? '40%' : '80%',
        marginVertical: 20,
        alignSelf: 'center'
    },
    subtitle: {
        ...fontStyles.subtitle,
        color: 'white',
        width: Device.isTabletOrWeb ? '50%' : '80%',
        marginVertical: 20,
        textAlign: 'center'
    },
    buttonContainer: {
        width: Device.isTabletOrWeb ? '50%' : '80%',
        flexDirection: Device.isTabletOrWeb ? 'row-reverse' : 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    button: { marginVertical: 10, marginHorizontal: Device.isTabletOrWeb ? 10 : 0, minWidth: '20%' }
});

export default defaultStyles;
